import { lazy } from 'react';

const StudyGroupsPage = lazy(() =>
  import('./groups/page.js').then((module) => ({ default: module.StudyGroupsPage })),
);
const StudyGroupDetailPage = lazy(() =>
  import('./groups/[id]/page.js').then((module) => ({ default: module.StudyGroupDetailPage })),
);
const StudyGroupSettingsPage = lazy(() =>
  import('./settings/page.js').then((module) => ({ default: module.StudyGroupSettingsPage })),
);

export { StudyGroupDetailPage, StudyGroupSettingsPage, StudyGroupsPage };
